import styled from 'styled-components';
import Colors from '../../themes/Colors';

export const WindowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "100%"};
  min-height: ${({ minHeight }) => minHeight || "500px"};
  max-height: ${({ maxHeight }) => maxHeight || "100%"};
  min-width: ${({ minWidth }) => minWidth || "500px"};
  max-width: ${({ maxWidth }) => maxWidth || "100%"};
  background-color: ${Colors.white};
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
`;

export const WindowsTabs = styled.div`
  display: flex;
  border-bottom: 2px solid ${Colors.primaryHumano};
  overflow-x: auto;
  overflow-y: hidden;
  min-height: 50px;
  max-height: 50px;
  padding: 0 4px;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${Colors.grayClean};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${Colors.primaryHumano};
    border-radius: 3px;
  }
`;

export const WindowsTab = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-right: 1px solid ${Colors.lineColor};
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  max-width: 220px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: ${props => props.active ? '8px 8px 0 0' : '0'};
  margin: 4px 2px 0 2px;

  &:last-child {
    border-right: none;
  }

  ${props => props.active && `
    border-bottom: 1px solid ${Colors.primaryHumano};
    font-weight: 600;
    box-shadow: 0 -2px 8px rgba(0, 187, 236, 0.2);
  `}
`;

export const WindowsTabIcon = styled.span`
  font-size: 16px;
  margin-right: 8px;
  flex-shrink: 0;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
  color: ${props => props.active ? Colors.primaryHumano : Colors.grayFont};
  transition: color 0.3s ease;
`;

export const WindowsTabTitle = styled.span`
  font-size: 16px;
  color: ${props => props.active ? Colors.primaryHumano : Colors.txt};
  font-weight: ${props => props.active ? '600' : '500'};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const WindowsContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const WindowsPanel = styled.div`
  flex: 1;
  padding: 20px;
  overflow: ${({ overflow }) => overflow || "none"};
  height: 100%;
  min-height: 500px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
  }

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background: ${Colors.grayClean};
    border-radius: 5px;
    margin: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    border: 2px solid ${Colors.white};
  }

  &::-webkit-scrollbar-thumb:hover {
  }
`;

export const WindowsContainerDark = styled(WindowsContainer)`
  background-color: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;

  ${WindowsTabs} {
    background-color: #1a202c;
    border-bottom-color: #4a5568;
  }

  ${WindowsTab} {
    border-right-color: #4a5568;
    color: #e2e8f0;

    &:hover {
      background-color: ${props => props.active ? '#2d3748' : '#4a5568'};
    }

    ${props => props.active && `
      border-bottom-color: #63b3ed;
    `}
  }

  ${WindowsTabTitle} {
    color: #e2e8f0;
  }

  ${WindowsPanel} {
    background-color: #2d3748;
    color: #e2e8f0;
  }
`;

export const WindowsContainerCompact = styled(WindowsContainer)`
  ${WindowsTabs} {
    min-height: 32px;
    max-height: 32px;
  }

  ${WindowsTab} {
    padding: 4px 8px;
    min-width: 100px;
    max-width: 150px;
  }

  ${WindowsTabIcon} {
    font-size: 12px;
    margin-right: 4px;
  }

  ${WindowsTabTitle} {
    font-size: 12px;
  }

  ${WindowsPanel} {
    padding: 12px;
  }
`;